import { AxiosError } from 'axios'
import { toast } from '@/hooks/use-toast'

export function handleServerError(error: unknown) {
  // eslint-disable-next-line no-console
  console.log(error)

  let errMsg = 'Đã xảy ra lỗi'

  if (error instanceof Error && error.message) {
    errMsg = error.message
  }

  if (error instanceof AxiosError) {
    const data = error.response?.data as
      | { title?: string; error?: string }
      | undefined
    errMsg = data?.error ?? data?.title ?? errMsg
  }

  if (
    error &&
    typeof error === 'object' &&
    'status' in error &&
    Number(error.status) === 204
  ) {
    errMsg = 'Không tìm thấy nội dung'
  }

  toast({ variant: 'destructive', title: errMsg })
}
